// extracted by mini-css-extract-plugin
export default {"related_div":"Footer_related_div__sArBN","footer_main_div":"Footer_footer_main_div__C+l1I","social_network":"Footer_social_network__Vx7g7"};